module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-down-black.dd2ebe7e.svg";